(function ($) {

    const initializeBlock = function ($block) {
      function matchHeightFire() {
        $('.awardItems .awardItem .awardItem-image').matchHeight( {property: 'min-height'} );
        $('.awardItems .awardItem .awardItem-title').matchHeight( {property: 'min-height'} );
      }
      matchHeightFire()

      $( window ).bind('resize orientationchange', function() {
          matchHeightFire();
      });

      setTimeout(function() {
          matchHeightFire();
      }, 1000)
    }

    $(document).ready(function () {
        $('.block--awards').each(function () {
            initializeBlock($(this));
        })
    })

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=awards', initializeBlock);
    }

})(jQuery);
